import { Form, Input, Radio, Row, Space, Spin } from "antd";
import { toastError, toastSuccess } from "helpers/toasters";
import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "modules/SubComponents/Buttons/SecondaryButton";
import {
  acceptRejectPendingOrderByAdminApi,
  getCollectionTypes,
} from "Network";
import React, { useEffect, useState } from "react";

export default function AcceptOrRejectModal({
  rowData,
  onCancel,
  setRenderMe,
  isApprove,
}) {
  const [collectionType, setCollectionType] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isApprove) {
      setLoading(true);
      getCollectionTypes(
        (success) => {
          setCollectionType(success.data);
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [isApprove]);

  const onFinish = (values) => {
    let payload = {
      orderId: rowData?.id,
      isAccepted: isApprove,
      BankTransferAmount: +values.BankTransferAmount || null,
      CashAmount: +values.CashAmount || null,
      CollectionTypeId: selectedType,
    };

    if (!isApprove) {
      payload = { orderId: rowData?.id, isAccepted: isApprove };
    }

    setSubmitting(true);
    acceptRejectPendingOrderByAdminApi(
      payload,
      (res) => {
        if (res.success) {
          setSubmitting(false);
          toastSuccess(res.message);
          onCancel();
          setRenderMe((prev) => !prev);
        } else {
          setSubmitting(false);
          toastError(res.message);
        }
      },
      (fail) => {
        setSubmitting(false);
        toastError(fail?.data?.error);
      }
    );
  };

  return (
    <>
      {isApprove && (
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Collection Type"
            name="CollectionTypeId"
            rules={[
              { required: true, message: "Please select collection type" },
            ]}
          >
            {loading ? (
              <Spin />
            ) : (
              <Radio.Group onChange={(e) => setSelectedType(e.target.value)}>
                {collectionType.map((opt) => (
                  <Radio key={opt.id} value={opt.id}>
                    {opt.name}
                  </Radio>
                ))}
              </Radio.Group>
            )}
          </Form.Item>

          {selectedType === 3 && !loading && (
            <>
              <Form.Item
                label="Bank Transfer Amount"
                name="BankTransferAmount"
                rules={[
                  {
                    required: true,
                    message: "Please enter bank transfer amount",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                label="Cash Amount"
                name="CashAmount"
                rules={[
                  { required: true, message: "Please enter cash amount" },
                ]}
              >
                <Input type="number" />
              </Form.Item>
            </>
          )}
          <Row className="d-flex justify-content-center mt-4">
            <Space size={20}>
              <SecondaryButton buttonName={"Cancel"} onClick={onCancel} />
              <PrimaryButton
                buttonName={"Confirm"}
                type="submit"
                disableMe={loading || submitting}
              />
            </Space>
          </Row>
        </Form>
      )}

      {!isApprove && (
        <>
          <h6 className="text-center">Are you sure you want to reject?</h6>
          <Row className="d-flex justify-content-center mt-4">
            <Space size={20}>
              <SecondaryButton buttonName={"Cancel"} onClick={onCancel} />
              <PrimaryButton
                buttonName={"Confirm"}
                type="button"
                onClick={onFinish}
                disableMe={loading || submitting}
              />
            </Space>
          </Row>
        </>
      )}
    </>
  );
}
